import {
	CHECK_MOBILE,
	CLEAR_AUTHENTICATION_DATA,
	LOGGED_IN_SUCCESS,
	MOBILE_DETAILS,
	CLEAR_MOBILE_DETAILS,
	CLEAR_USER_DETAILS,
	MOBILE_EXIST,
	MOBILE_NOT_EXIST,
	REGISTER_USER,
	REGISTER_USER_FAILED,
	REGISTER_USER_SUCCESS,
	SEND_OTP,
	SEND_OTP_SUCCESS,
	VERIFY_EMAIL,
	UPDATE_MOBILE,
	UPDATE_MOBILE_REQUEST,
	UPDATE_MOBILE_SUCCESS,
	VERIFY_OTP,
	USER_DETAILS,
	LOGOUT_REQUEST,
	LOGOUT_SUCCESS,
	LOGOUT_FAILED,
	REQUEST_LOGIN,
	VERIFY_EMAIL_SUCCESS,
	UPDATE_MOBILE_FAILED,
	OTP_VERIFICATION_FAILED,
	CITY_FOR_ZIP_CODE_SUCCESS,
	CITY_FOR_ZIP_CODE_FAILED,
	INITIATE_AUTHENTICATION,
	STOP_AUTHENTICATION,
	INITIATE_AUTH_DRAWER,
	STOP_AUTH_DRAWER
} from '../actions/types';

const authentications = (
	state = {
		status: undefined,
		updateMobileStatus: undefined,
		otpVerificationStatus: undefined,
		checkMobile: { isUser: '', message: '' },
		login: {},
		loggedIn: {},
		loggedOut: {},
		registered: {},
		updateMobile: '',
		updateMobileRequest: false,
		mobileDetails: {},
		userDetails: {},
		isRequestedLogin: false,
		authenticationInitiated: false,
		authDrawerInitiated: false
	},
	action
) => {
	switch (action.type) {
		case CHECK_MOBILE:
			return Object.assign({}, state, { status: 'checking', otpVerificationStatus: '' });
		case MOBILE_EXIST:
			return Object.assign({}, state, { status: 'success', checkMobile: { isUser: 'userExist', message: 'User already exist.' } });
		case MOBILE_NOT_EXIST:
			return Object.assign({}, state, { status: 'success', checkMobile: { isUser: 'newUser', message: 'No user account found.' } });
		case SEND_OTP:
			return Object.assign({}, state, { status: 'fetching', otpVerificationStatus: '' });
		case SEND_OTP_SUCCESS:
			return Object.assign({}, state, { status: 'success', login: action.data });
		case VERIFY_EMAIL:
			return Object.assign({}, state, { status: 'verifying' });
		case VERIFY_EMAIL_SUCCESS:
			return Object.assign({}, state, { status: 'success' });
		case VERIFY_OTP:
			return Object.assign({}, state, { status: 'verifying', otpVerificationStatus: 'verifying' });
		case OTP_VERIFICATION_FAILED:
			return Object.assign({}, state, { status: 'failed', otpVerificationStatus: 'failed', loggedIn: action.data });
		case LOGGED_IN_SUCCESS:
			return Object.assign({}, state, { status: 'success', otpVerificationStatus: 'success', loggedIn: action.data });
		case USER_DETAILS:
			return Object.assign({}, state, { status: 'userdata', userDetails: action.payload });
		case CLEAR_USER_DETAILS:
			return Object.assign({}, state, { status: 'cleardata', userDetails: {} });
		case REGISTER_USER:
			return Object.assign({}, state, { status: 'creating' });
		case REGISTER_USER_SUCCESS:
			return Object.assign({}, state, { status: 'success', registered: action.data });
		case REGISTER_USER_FAILED:
			return Object.assign({}, state, { status: 'success', registered: action.data });
		case MOBILE_DETAILS:
			return Object.assign({}, state, { status: 'success', mobileDetails: { ...state.mobileDetails, ...action.payload } });
		case CLEAR_MOBILE_DETAILS:
			return Object.assign({}, state, { status: 'deleted', mobileDetails: action.payload, checkMobile: { isUser: '', message: '' } });
		case UPDATE_MOBILE:
			return Object.assign({}, state, { status: 'updating', updateMobileStatus: 'updating' });
		case UPDATE_MOBILE_SUCCESS:
			return Object.assign({}, state, { status: 'success', updateMobileStatus: 'success', updateMobile: action.data });
		case UPDATE_MOBILE_FAILED:
			return Object.assign({}, state, { status: 'failed', updateMobileStatus: 'failed' });
		case UPDATE_MOBILE_REQUEST:
			return Object.assign({}, state, { updateMobileStatus: 'updating', updateMobileRequest: action.payload });
		case LOGOUT_REQUEST:
			return Object.assign({}, state, { status: 'logout' });
		case LOGOUT_SUCCESS:
			return Object.assign({}, state, { status: 'loggedOut', loggedOut: action.data });
		case LOGOUT_FAILED:
			return Object.assign({}, state, { status: 'failed' });
		case REQUEST_LOGIN:
			return Object.assign({}, state, { isRequestedLogin: action.payload.isLogin });
		case CLEAR_AUTHENTICATION_DATA:
			return Object.assign({}, state, { status: undefined, login: {}, loggedIn: {}, loggedOut: {}, registered: {}, updateMobile: '', updateMobileRequest: false });
		case CITY_FOR_ZIP_CODE_SUCCESS:
			return Object.assign({}, state, { status: 'success', cityForZipCode: action.data });
		case CITY_FOR_ZIP_CODE_FAILED:
			return Object.assign({}, state, { status: 'failed', cityForZipCode: null }); 
		case INITIATE_AUTHENTICATION:
			return Object.assign({}, state, { status: 'failed', authenticationInitiated: true }); 
		case STOP_AUTHENTICATION:
			return Object.assign({}, state, { status: 'failed', authenticationInitiated: false }); 
		case INITIATE_AUTH_DRAWER:
			return Object.assign({}, state, { status: 'failed', authDrawerInitiated: true }); 
		case STOP_AUTH_DRAWER:
			return Object.assign({}, state, { status: 'failed', authDrawerInitiated: false });
		default:
			return state;
	}
};

export default authentications;
